// extracted by mini-css-extract-plugin
export default {"pseudoSelect":"styles-module--pseudoSelect--fhfui"};